import * as React from 'react';
import * as aguiV4 from '../shared/v4';

class TestCoolTextInputV4 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            validation: new Map(),
            valore: "Valore"
        };
        this.invia = this.invia.bind(this);
        this.inputChangeHandler = this.inputChangeHandler.bind(this);
        this.componentName = "[TestCoolTextInputV4.jsx] ";
    }


    inputChangeHandler(e, index) {
        // console.log(this.componentName + ' handleChange id: ' + id + ' value: ' + value);
        if (e !== null && e !== undefined) {
            let obj = {};
            let value = e.target.value;
            let id = e.target.id;
            obj[id] = value;
            this.setState(obj)
        }
    }

    invia() {
        //aggiungere la parte di validazione ... 
        if (!this.validateForm()) {
            console.log('validateForm return false');
            return null;
        }


        let log = document.getElementById('log');
        log.insertAdjacentHTML('beforeend', '<h1> valore </h1> ' + this.state.valore);
    }

    validateForm() {
        let validation = new Map();
        let required = ['valore'];
        for (let i = 0; i < required.length; i++) {
            if (this.state[required[i]] === undefined || this.state[required[i]] === '' || this.state[required[i]] === null) {
                validation.set(required[i], 'valore obbligatorio');
            }
        }
        this.setState({ validation: validation });
        if (validation.size === 0) {
            return true;
        }
        return false;
    }

    render() {
        console.log(this.componentName + "render");
        return (
            <div className="col-md-3" >
                {/* 
                <agui.ACoolTextInputV4 id="valore"
                    type="text"
                    value={this.state.valore}
                    placeholder="test"
                    autocomplete="off"
                    required={true}
                    label="test"
                    validation={this.state.validation}
                    onChange={this.inputChangeHandler} /> */}
                <br></br>
                <br></br>
                <agui.CoolTextInputV4 id="valore"
                    type="text"
                    value={this.state.valore}
                    placeholder="test"
                    autocomplete="off"
                    required={true}
                    label="test"
                    validation={this.state.validation}
                    onChange={this.inputChangeHandler} />

                <hr />
                <button className="btn btn-info" onClick={this.invia}> Invia </button>
                <div id="log"></div>

            </div>
        );
    }
}
export default TestCoolTextInputV4;